import type { InteractionMode } from "@/lib/scenarios/interactionModes";
import type { RolePlayConfig } from "@/lib/powtoon-be/types";
import { buildRolePlayPrompt } from "./rolePlay";

export function buildContextPrompt(context: {
  mode?: InteractionMode;
  persona?: string;
  knowledge?: string;
  instructions?: string;
  roleplay?: RolePlayConfig;
}) {
  const mode = context.mode ?? "conversational";

  const persona = (context.persona ?? "").trim();
  const knowledge = (context.knowledge ?? "").trim();
  const instructions = (context.instructions ?? "").trim();

  if (mode === "multiple_choice") {
    const parts: string[] = ["MODE: Open-Answer Assessment"];
    if (persona) {
      parts.push(`PERSONA:\n____\n${persona}\n____`);
    }
    parts.push(
      `QUESTIONNAIRE:\nBelow are the question(s) — could be one or many. Ask the learner each question, one at a time. Offer hints when requested. Compare their answer to the listed valid answers (accept synonyms and paraphrases). Give brief feedback after each answer.\n\nDo NOT disclose the score or running tally at any point.\n_____\n${knowledge}\n_____`,
    );
    if (instructions) {
      parts.push(`INSTRUCTIONS:\n_____\n${instructions}\n_____`);
    }
    return parts.join("\n\n");
  }

  if (mode === "role_play") {
    if (context.roleplay) {
      return buildRolePlayPrompt(context.roleplay, instructions);
    }
    return `
MODE: Role Play Examination

SCENARIO AND ROLES:
You will play the avatar role described below. The learner plays the counterpart
role. Stay in character. Drive the conversation realistically and evaluate the
learner against the success criteria at the end.
_____
${knowledge}
_____
    `.trim();
  }

  const parts: string[] = ["MODE: Conversational Training"];
  if (persona) {
    parts.push(
      `PERSONA:\nEvery time that you respond to user input, you must adopt the following persona:\n____\n${persona}\n____`,
    );
  }
  parts.push(
    `KNOWLEDGE BASE:\nEvery time that you respond to user input, provide answers from the below knowledge.\nAlways prioritize this knowledge when replying to users:\n_____\n${knowledge}\n_____`,
  );
  if (instructions) {
    parts.push(
      `INSTRUCTIONS:\nYou must obey the following instructions when replying to users:\n_____\n${instructions}\n_____`,
    );
  }
  return parts.join("\n\n");
}